export default __webpack_public_path__ + "static/media/felix-portfolio.251127cf.png";